import styled, { css } from 'styled-components';
export const PasswordFieldWrapper = styled.div `
  ${({ theme, $state, $isFocused }) => css `
    ${theme.getFontStyle('samsung-400-14')};
    border: 1px solid
      ${$isFocused
    ? theme.getColor('black', 'default')
    : $state === 'error'
        ? theme.getColor('error', 'default')
        : theme.getColor('gray', '05')};
    border-radius: 8px;
    background-color: ${theme.getColor('white')};
    color: ${theme.getColor('black')};
    &::placeholder {
      color: ${theme.getColor('gray', '03')};
    }
  `};
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 12px;
`;
export const IconWrapper = styled.div `
  display: flex;
  align-items: center;
  column-gap: 4px;
`;
export const PasswordInput = styled.input `
  flex: 1;
  height: 100%;
  /* Chrome, Edge에서 비밀번호 아이콘 제거 */
  &::-ms-reveal,
  &::-ms-clear {
    display: none;
  }

  &::-webkit-contacts-auto-fill-button,
  &::-webkit-credentials-auto-fill-button,
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button,
  &::-webkit-search-cancel-button {
    display: none;
  }
`;
//# sourceMappingURL=PasswordField.styles.js.map